import React from 'react'
import PropTypes from 'prop-types'
import Spider from './assets/spider.png'
import Web from './assets/web.png'
import './styles.scss'

const SpiderWeb = ({ onClick }) => {
  return (
    <button
      className="btn btn-link p-0 absolute spider-web spider-web-container"
      onClick={() => {
        if (
          confirm(
            '🕷️You pleased the 🕸️ spider very much. 🕸️ Spider wants to know if you want a fresh start? 🕷️'
          )
        )
          onClick()
      }}
    >
      <img src={Web} />
      <img className="absolute spider-web spider-web-spider" src={Spider} />
    </button>
  )
}

SpiderWeb.propTypes = {
  onClick: PropTypes.func
}

export default SpiderWeb
